import { render, staticRenderFns } from "./ProductRichTextEditor.vue?vue&type=template&id=129f931c&scoped=true"
import script from "./ProductRichTextEditor.vue?vue&type=script&lang=js"
export * from "./ProductRichTextEditor.vue?vue&type=script&lang=js"
import style0 from "./ProductRichTextEditor.vue?vue&type=style&index=0&id=129f931c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "129f931c",
  null
  
)

export default component.exports